import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Subscription, filter, startWith } from 'rxjs';

import { ColorSchemeService } from '../color-scheme.service';
import { KarveTabviewComponent } from '../shared/karve-tabview/karve-tabview.component';

@Component({
    selector: 'app-users',
    standalone: true,
    imports: [
        BreadcrumbModule,
        KarveTabviewComponent,
        RouterOutlet,
    ],
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {

    home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };

    breadcrumb: MenuItem[] = [
        { label: 'People' },
    ];

    tabs = [
        { name: 'Customers', slug: 'customers' },
        { name: 'Employees', slug: 'employees' },
        { name: 'Crew', slug: 'crew' },
    ];

    private routeSub: Subscription | undefined;

    constructor(
        public colorScheme: ColorSchemeService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.routeSub = this.router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            startWith(null),
        ).subscribe(() => {
            const slug = this.route.firstChild?.snapshot.url[0]?.path;
            const tab = this.tabs.find((t) => t.slug === slug);
            this.breadcrumb = [
                { label: 'People' },
                ...(tab ? [{ label: tab.name }] : []),
            ];
        });
    }

    ngOnDestroy(): void {
        this.routeSub?.unsubscribe();
    }
}